// extracted by mini-css-extract-plugin
export default {"Header":"IconBlock_Header__s1NTY","Body":"IconBlock_Body__HRxyW","IconWrap":"IconBlock_IconWrap__ybRJ-"};